export default __webpack_public_path__ + "static/media/gallery_09.8c608f61.jpg";